export default {
  Yn: "allowCrawlerActivity",
  Xn: "baseUrl",
  Zn: "noCookies",
  ho: "devicePropertyAllowlist",
  ia: "disablePushTokenMaintenance",
  po: "enableLogging",
  Eo: "enableSdkAuthentication",
  ta: "manageServiceWorkerExternally",
  _o: "minimumIntervalBetweenTriggerActionsInSeconds",
  Io: "sessionTimeoutInSeconds",
  Ao: "appVersion",
  na: "serviceWorkerLocation",
  ra: "safariWebsitePushId",
  jn: "localization",
  ao: "contentSecurityNonce",
  So: "enableHtmlInAppMessages",
  No: "allowUserSuppliedJavascript",
  no: "inAppMessageZIndex",
  lo: "openInAppMessagesInNewTab",
  en: "openNewsFeedCardsInNewTab",
  Ih: "requireExplicitInAppMessageDismissal",
  wo: "doNotLoadFontAwesome",
  To: "sdkFlavor",
  tn: "openCardsInNewTab"
};
